import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_mst_cashbook_hdr_RowClass, bl_fi_cashbook_txn_line_RowClass,  } from "../../../dbschema";

export class CashLevelContainerModel extends BaseContainerModel {
    bl_fi_mst_cashbook_hdr: bl_fi_mst_cashbook_hdr_RowClass = new bl_fi_mst_cashbook_hdr_RowClass();
    bl_fi_cashbook_txn_lines: bl_fi_cashbook_txn_line_RowClass[] = [];
}
